import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { API_ENDPOINT } from './../_config/config';

/** A named, coloured project tag (file rows carry only id, name and color) */
export interface Tag {
    id: string;
    name: string;
    color: string;
    project?: string;
    createdAt?: string;
    fileCount?: number;
}

/** Black or white, whichever reads better on a '#rrggbb' tag colour */
export function tagTextColor(color: string) {
    const [r, g, b] = [1, 3, 5].map(i => parseInt(color.slice(i, i + 2), 16));
    return r * 0.299 + g * 0.587 + b * 0.114 > 150 ? '#000' : '#fff';
}

@Injectable({
    providedIn: 'root'
})
export class TagService {
    constructor(private http: HttpClient) { }

    /** Get a project's tags with their file counts, sorted by name */
    list(projectId: string) {
        return this.http.get<{ tags: Tag[], count: number }>(`${API_ENDPOINT}/projects/${projectId}/tags`);
    }

    get(projectId: string, tagId: string) {
        return this.http.get<{ tag: Tag }>(`${API_ENDPOINT}/projects/${projectId}/tags/${tagId}`);
    }

    create(projectId: string, tag: { name: string, color: string }) {
        return this.http.post<{ tag: Tag }>(`${API_ENDPOINT}/projects/${projectId}/tags`, tag);
    }

    update(projectId: string, tagId: string, tag: { name?: string, color?: string }) {
        return this.http.patch<{ tag: Tag }>(`${API_ENDPOINT}/projects/${projectId}/tags/${tagId}`, tag);
    }

    /** Delete a tag; it is taken off its files */
    delete(projectId: string, tagId: string) {
        return this.http.delete<{ message: string }>(`${API_ENDPOINT}/projects/${projectId}/tags/${tagId}`);
    }

    /** Replace the files' tags with exactly tagIds ([] untags them) */
    setFileTags(projectId: string, fileIds: string[], tagIds: string[]) {
        return this.http.put<{ tagged: number }>(`${API_ENDPOINT}/projects/${projectId}/files/tags`, { fileIds, tagIds });
    }
}
